import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-body p-xl-40" }
const _hoisted_2 = { class: "card-title fw-semiBold fs-18 mb-30" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_4 = {
  key: 1,
  class: "table-responsive style-five"
}
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ps-0"
}
const _hoisted_7 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_8 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 pe-0"
}
const _hoisted_11 = { class: "shadow-none fw-normal text-black title ps-0" }
const _hoisted_12 = { class: "text-optional fs-14" }
const _hoisted_13 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_14 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_15 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_16 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_17 = { class: "text-red fw-bold" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  colspan: "5",
  class: "text-center py-4 text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.$t("dashboard_page.stock_alert")), 1),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("loading")), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("dashboard_page.code")), 1),
                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("dashboard_page.product")), 1),
                _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("dashboard_page.warehouse")), 1),
                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("dashboard_page.quantity")), 1),
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("dashboard_page.alert_quantity")), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockAlerts, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(item.SKU), 1)
                  ]),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.product_name), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.warehouse_name || _ctx.$t("dashboard_page.not_available")), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(item.quantity), 1),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(item.stock_alert), 1)
                  ])
                ]))
              }), 128)),
              (_ctx.stockAlerts.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$t("dashboard_page.no_stock_alerts")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
  ]))
}